import React, { useEffect } from 'react';
import ResetForm from '../../components/auth/ResetForm';

const Reset = ({ match }) => {

	useEffect(() => {
		document.getElementById('body').classList.add('loginContainer');
	}, []) 

	return (
		<main className="form-signin">
			<div>
				<div className="signIn">
					<img className="logInLogoUno" src="/assets/img/logo_vertical_new.png" alt=""/>
					<div className="col-xl-4 col-lg-6 col-md-6 col-12 mx-auto singin-form">
						<ResetForm
							token={match.params.token}
							url={`${process.env.REACT_APP_API}/auth/reset-password`}
							buttonMessage="Recuperar contraseña"
						/>
					</div>
					<img className="logInLogoDos" src="/assets/img/logo_viacottone_new.png" alt="Logo Viacotone"/>
				</div>
			</div>
		</main>
	)
}

export default Reset;
